import * as React from "react";
import { SVGProps } from "react";

const Eos = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 50" {...props}>
    <path d="M16.6 0 4.9 16.1 0 39.9 16.6 50l16.6-10.1-5-23.9ZM2.7 38.8l3.7-18.1 8.4 25.5Zm4.9-22.2 9-12.4 9 12.4-9 27.2Zm10.7 29.6 8.4-25.5 3.7 18.1Z" />
  </svg>
);

export default Eos;
